<template>
  <div id="hero" class="m-0" data-aos="fade">
    <div class="d-flex justify-content-between  align-items-stretch flex-column pt-5">
    <div class="container padding">
        <div class="text">
          <h2>
            <span>Collaborating</span><br />
            <span>for Public Good?</span>
          </h2>
          <p>
            <span>Need some model legal documents/templates?</span><br />
            <span>You are in the Right Place.</span>
          </p>
          <p class="subscribe">
          <a href="/user/register" class="btn my-4 font-weight-bold atlas-cta cta-green">
              subscribe
          </a>
          </p>
        </div>  
      </div>
      <div class="container align-self-baseline">
        <div class=" levi">
          <div class="">
            <div class="">
              <img src="../assets/white-back-Logo.png" alt="" class="img-fluid img-responsive">
            </div>
            <p class="">An Initiative of LEVI</p>
          </div>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
import $ from 'jquery'
		$(function() {   
		
			var theWindow        = $(window),
			    $bg              = $("#hero"),
			    aspectRatio      = $bg.width() / $bg.height();
			    			    		
			function resizeBg() {
				
				if ( (theWindow.width() / theWindow.height()) < aspectRatio ) {
				    $bg
				    	.removeClass()
				    	.addClass('bgheight');
				} else {
				    $bg
				    	.removeClass()
				    	.addClass('bgwidth');
				}
							
			}
			                   			
			theWindow.resize(function() {
				resizeBg();
			}).trigger("resize");
		
		});
export default {
    name:'home'
}
</script>

<style scoped>

.text h2{
  font-weight: 900;
  font-size: 4em;
  opacity: 0.8;
}
.text p{
  font-size: 1.4em;
  font-weight: 600;
}
/*
.text a 
 background-color: rgb(53, 2, 2) !important;
 color:white;
 padding: 10px 20px;
 border-radius: 15px;
 font-size: 1.2em;
} */
.atlas-cta {
    border-radius: 22px !important;
    padding: 12px 30px !important;
    font-weight: 700;
    transition: .3s ease-in-out !important;
}

.atlas-cta:hover {
    text-decoration: none;
    transform: translateY(-5px);
}
.cta-green {
    background: #00FFAD;
    color: #192440;
}

.cta-green:hover {
    color: #ffffff;
    background: #00e69c;
}
.levi img{
  width: 80px;
  height: 80px;
  margin-left: 1.7em;
}
.levi{
  padding-top: 3em;
}
.subscribe {
 margin-top: 2em;
 margin-bottom: 1em;
}
.text {
  padding-top:3em
}
@media screen and (max-width:767px) {
  .text h2{
  font-weight: 800;
  font-size: 3em;
}
}
@media screen and (max-width:420px) {
  .text h2{
  font-weight: 800;
  font-size: 2.5em;
} 
}
</style>